
import { defineComponent,ref,Ref,provide,watchEffect,onMounted,computed,PropType } from 'vue';
import {IDoc,IFile} from "@/models/files.interface";
import {FilesService} from "@/services/files.service";
import {UserService} from "@/services/user.service";

export default defineComponent({
  name: 'File',
  props:{
    file:{
	type: Object as PropType<IFile> 
      }
  },
  setup(props,context){
    const imgStatus= (status)=>{
	 let img="../img/water-tap.png"; 
	switch(status){
	  case "unattended":
	    img=require("@/img/water-tap.png");
	    break;
	  case "asigned":
	    img = require("@/img/dia.png");
	    break;
	  case "closed":
	    img = require("@/img/tap.png");
	    break;
	 }
	return img;
      };
    const serviceUser = new UserService();
    const serviceFile = new FilesService();

    const toAsign = (idDoc:string)=>{
      const exito = serviceFile.changeStatus(serviceUser.fetch().token,idDoc,"asigned");
      if (exito){
	console.log("cambiado");
      }
    }
    const toClose = (idDoc:string)=>{
      const exito =  serviceFile.changeStatus(serviceUser.fetch().token,idDoc,"closed");
      if (exito){
	console.log("cambiado");
      }
    }
    const download_file = (id:string)=>{
      serviceFile.downloadFile(serviceUser.fetch().token,id);
    }
    return {imgStatus,toAsign,toClose,download_file}
  }//fin de setup

});
